import { t } from './i18n';

export const BAN_ACTION = 'ban';
export const UNBAN_ACTION = 'unban';

/** Matches auth-admin-api-serverless model.AccountInactiveReason* */
export const ACCOUNT_INACTIVE_REASON_NONE = 0;
export const ACCOUNT_INACTIVE_REASON_DEACTIVATION = 1;
export const ACCOUNT_INACTIVE_REASON_RESIGNATION = 2;
export const ACCOUNT_INACTIVE_REASON_BAN = 3;
export const ACCOUNT_INACTIVE_REASON_SUSPENSION = 4;

export function getUserId(user) {
  return user?.user_id ?? user?.UserID ?? null;
}

export function getUserUsername(user) {
  return user?.username ?? user?.Username ?? '';
}

export function getUserAccountType(user) {
  return user?.account_type ?? user?.AccountType ?? 'USER';
}

export function getUserAccountStatus(user) {
  return user?.account_status ?? user?.AccountStatus ?? 0;
}

export function getUserAccountInactiveReason(user) {
  const raw = user?.account_inactive_reason ?? user?.AccountInactiveReason;
  if (raw === null || raw === undefined) return null;
  const n = Number(raw);
  return Number.isNaN(n) ? null : n;
}

function hasRetainedEmail(user) {
  const enc = user?.encrypted_email ?? user?.EncryptedEmail;
  if (enc != null && String(enc).trim() !== '') return true;
  const plain = user?.email ?? user?.Email;
  return plain != null && String(plain).trim() !== '';
}

function hasDeletedAt(user) {
  return (user?.deleted_at ?? user?.DeletedAt) != null;
}

/** Admin ban row for list filter (reason=3 or legacy ban fingerprint). */
export function isAdminBannedUser(user) {
  if (getUserAccountType(user) !== 'USER') return false;
  const reason = getUserAccountInactiveReason(user);
  if (reason === ACCOUNT_INACTIVE_REASON_BAN) return true;
  if (reason === ACCOUNT_INACTIVE_REASON_SUSPENSION || reason === ACCOUNT_INACTIVE_REASON_RESIGNATION || reason === ACCOUNT_INACTIVE_REASON_DEACTIVATION) {
    return false;
  }
  return getUserAccountStatus(user) === 0 && hasDeletedAt(user) && hasRetainedEmail(user);
}

export function canBanUser(user) {
  return getUserAccountType(user) === 'USER' && (getUserAccountStatus(user) === 1 || (getUserAccountStatus(user) === 0 && getUserAccountInactiveReason(user) === ACCOUNT_INACTIVE_REASON_SUSPENSION));
}

/** Unban only when inactive USER was admin-banned (account_inactive_reason=3). */
export function canUnbanUser(user) {
  return (
    getUserAccountType(user) === 'USER'
    && getUserAccountStatus(user) === 0
    && getUserAccountInactiveReason(user) === ACCOUNT_INACTIVE_REASON_BAN
  );
}

/** @returns {'ban'|'unban'|null} */
export function getBanAction(user) {
  if (canBanUser(user)) return BAN_ACTION;
  if (canUnbanUser(user)) return UNBAN_ACTION;
  return null;
}

export function mapBanError(err) {
  const apiMsg = err?.data?.msg || err?.data?.message;
  switch (err?.status) {
    case 403:
      return t('user.ban.error.forbidden');
    case 404:
      return t('user.ban.error.notFound');
    case 409:
      return apiMsg || t('user.ban.error.conflict');
    default:
      return apiMsg || err?.message || t('user.ban.error.generic');
  }
}
